import { render, staticRenderFns } from "./RouterLinkGuard.vue?vue&type=template&id=a79c569a&"
import script from "./RouterLinkGuard.vue?vue&type=script&lang=js&"
export * from "./RouterLinkGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports